import { render, staticRenderFns } from "./TrainingListDetail.vue?vue&type=template&id=56c1084b&scoped=true&"
import script from "./TrainingListDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingListDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingListDetail.vue?vue&type=style&index=0&id=56c1084b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c1084b",
  null
  
)

export default component.exports